import { Vars } from './../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 

import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit';
import { EmployeeTtype } from '../entities/employeeTtype';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { CostCenter } from '../entities/costCenter';
import { ParamsReportIncomeSummary } from '../model/params-report-income-summary';
import { IncomeSummaryDTO } from '../model/income-summary-dto';


interface ExtraSearchFields { 
  object? :any;
  executingUnit?: ExecutingUnit, 
  employeeType?: EmployeeTtype,
  startDate?: Date,
  endDate?: Date, 
  absenceType : Hhelpdesk ,  
  costCenter : CostCenter, 
}

@Injectable()
export class ReportIncomeSummaryService extends BaseReportService<IncomeSummaryDTO> {

  public uri = '/api/reportIncomeSummary/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance ReportAbsenceDetailService');
  }
  
  buildSentence(entity?: IncomeSummaryDTO, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );  
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  } 
  
  searchToReport(entity?: IncomeSummaryDTO, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<IncomeSummaryDTO>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<IncomeSummaryDTO>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          } 
          this.spinnerService.hideAll();
          return response;
        })
      );
  }
/*
  searchToViewTable(   fiscalYear:any,
    executingUnit:any,
    employeeType:any,
    startDateRange01:any,
    startDateRange02:any,
    absenceType:any,
    absence:any,
    costCenter:any,
    employee:any,
    object:Vars 
    ): Observable<any> {
      var params = new HttpParams()
        .set('fiscalYear',fiscalYear)
        .set('executingUnit',executingUnit) 
        .set('employeeType', employeeType)
        .set('startDateRange01', startDateRange01)
        .set('startDateRange02', startDateRange02)
        .set('absenceType', absenceType)
        .set('absence', absence)
        .set('costCenter', costCenter)
        .set('employee', employee)  
       //console.log(event);
       
console.log(params);
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        return this.httpClient.post<any>(url, object ,{params},)
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       ); 
  } 
 */

  searchToViewTable( paramsReportIncomeSummary : ParamsReportIncomeSummary): Observable<any> {
         this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        return this.httpClient.post<any>(url, paramsReportIncomeSummary  )
        .pipe(
          tap(response => {
            //this.spinnerService.hideAll();
            return response;
          }, 
           err =>{
            this.spinnerService.hideAll();
             //console.log("en el service error : "  , err );
           //   err.error.messages.forEach(message => {
           //   this.notificationService.serverErrorMessage(`${err.status} - -- ${message}`); 
           // })
           this.notificationService.serverErrorMessage(err.status +' - '+ err.error.messages[0]);
            return new Observable<any>();
          },
           ()=>{
             //console.log("complementando finally ...");
             this.spinnerService.hideAll();
           })
           ,
            catchError((err) => { 
              //this.spinnerService.hideAll();
              //console.log("en el catch error"); 
               return new Observable<Blob>();
           })
           
          ) ;
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-income-summary.service.ts